module.exports = __webpack_public_path__ + "media/images/design/common/images/icon_line-17f6bc535141e07c4dd60b8f314f9ffd.jpg";